var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutOldEuropean",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-old-european","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M125.3-.2C56.7-.2.8 55.7.8 124.3s55.9 124.5 124.5 124.5 124.5-55.9 124.5-124.5S194-.2 125.3-.2zm71.4 119.6l-26-13.3 5.9-28.2 47.4 4.4-27.3 37.1zm-170 49.1l26.8-36.3L76 143.7l-9.5 27.9-39.8-3.1zM82.8 23.1l34.1 29.7 3.1 6-9.7 18.8-31.9-9.3 4.4-45.2zm82 2.2l3.5 45.1-28.5 7.4-9.7-18.9 3.1-6 31.6-27.6zm-2.1 74.9l-16.1-14.9L167 80l-4.3 20.2zm-32.6-21.7H120l5.1-9.8 5 9.8zm-26.4 6.6l-19.2 17.7L79.3 78l24.4 7.1zm-43 40.7l16.3-8.3v16.6l-16.3-8.3zM84 148.1l17.5 16.2-25.5 7.5 8-23.7zm4.2-8.3l-2.2-1.1v-25.8l2.2-1.1 26.2-24.2h21.4l24.8 23v30.5l-21.9 20.3-.5-.1H112l-.5.1-23.3-21.6zm43.4 30.4l-6.5 12.6-6.5-12.6h13zm9.5 1.1l30.7 7.9-3.7 49.8-34.9-30.4-3.1-6 11-21.3zm7.8-7.2l14.2-13.2 6.3 18.5-20.5-5.3zm20.6-48.5l19.9 10.1-19.9 10.1v-20.2zm3.9-96.3c9.7 4.4 18.6 10.2 26.6 17l-23.3 25.9-3.3-42.9zM129 44.6V8.9c11.8.4 23.2 2.5 33.8 6.2L129 44.6zm-9-1L87.5 15.2C97.7 11.6 108.7 9.5 120 9v34.6zM70 61.4L48.9 37.8c7.6-6.7 16-12.4 25.1-17l-4 40.6zm-.1 15.5l6.5 30.8-22.9 11.7-28.8-39 45.2-3.5zm-27.3 42.9H9.9c.5-12.3 2.9-24 6.9-35l25.8 35zm2.1 9l-27.2 36.9c-4.4-11.5-7.1-23.9-7.6-36.9h34.8zM59.5 180l-23.1 17.9c-5.3-6.4-9.9-13.3-13.7-20.8l36.8 2.9zm19.1 49.9L75 181.3h.5l33.6-9.8 10.9 21.2-3.1 6-36.7 32c-.5-.3-1.1-.5-1.6-.8zm41.4-22v31.8c-10.5-.5-20.6-2.4-30.2-5.5l30.2-26.3zm9-.9l31.4 27.4c-10 3.2-20.5 5.1-31.4 5.4V207zm51.2-18.9l19.5 24.6c-6.8 5.8-14.4 10.8-22.4 14.8l2.9-39.4zm-9.4-42.7l25.9-13.2 25.4 34.4-42.7 3.9-8.6-25.1zm34.6-16.6h35.3c-.5 13.1-3.2 25.7-7.8 37.4l-27.5-37.4zm2.1-9l26.2-35.5c4.1 11.1 6.6 23.1 7.1 35.5h-33.3zm21.7-46l-46.9-4.3 24.3-27.1c9.2 9 16.8 19.7 22.6 31.4zM42.4 44.1l21.8 24.3-41.5 3.2c5.1-10.2 11.8-19.4 19.7-27.5zm0 160.5l23.9-18.5 2.9 39.1c-9.9-5.5-18.9-12.4-26.8-20.6zm163.9 2l-21.8-27.5 43.8-4 .5.6c-5.8 11.5-13.4 22-22.5 30.9z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-old-european.svg